// modules
import React, { FC, useCallback } from 'react';
import { Button, View } from '@upstox/upstox-ui';
import { observer } from 'mobx-react';
import LocaleService from 'modules/Localization';
import { useStore } from 'modules/Stores';
// services
import PriceAlerts from 'modules/PriceAlerts';
// styles
import * as css from './styles';

const DeletePriceAlert: FC = () => {
  const { getLoading } = useStore('LoadingStore');
  const { setModalType, toDeleteAlertId } = useStore('PriceAlertsStore');
  const deleteLoading = getLoading('PRICE_ALERT_DELETE');
  const handleCancelAlertClick = useCallback(() => {
    setModalType('List');
  }, [setModalType]);

  const handleDeleteAlertClick = useCallback(async () => {
    if (toDeleteAlertId) {
      const toEditAlert = PriceAlerts
        .priceAlertList
        .find(item => item.id === toDeleteAlertId);
      const exchangeToken = `${toEditAlert?.instrument.e}|${toEditAlert?.instrument.t}`;
      const isTriggered = toEditAlert?.rules.every(item => item.status === 'TRIGGERED');
      const response = await PriceAlerts
        .deletePriceAlert(toDeleteAlertId, exchangeToken, !isTriggered);
      if (response) {
        setModalType('List');
        PriceAlerts.getPriceAlerts();
      }
    }
  }, [toDeleteAlertId, setModalType]);

  return (
    <View justifyContent="flex-end" gap="small" alignItems="center" css={css.container}>
      <Button css={css.NoButton} onClick={handleCancelAlertClick}>
        {LocaleService.translate('DELETE_ALERT_BUTTON_NO')}
      </Button>
      <Button
        css={css.YesButton}
        onClick={handleDeleteAlertClick}
        disabled={deleteLoading}
        isLoading={deleteLoading}
      >
        {LocaleService.translate('DELETE_ALERT_BUTTON_YES')}
      </Button>
    </View>
  );
};

export default observer(DeletePriceAlert);
